<!-- successPart -->
<template>
  <div class="box">
    <img class="icon" :src="paperListItem.tabIcon" alt="">
    <div class="text">{{ paperListItem.tabFrontName }}</div>
    <div class="btn" @click="onClick">去体验</div>
    <img class="img" src="../../../assets/img/payment/unlockIcon.png" alt="">
  </div>
</template>

<script>
export default {
  props: {
    paperListItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onClick() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToTkPage', this.paperListItem?.subjectId, false);
      } else {
        this.$toast('请前往APP端练习页体验吧~');
      }
    },
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
.box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 105px;
  margin-top: 18px;
  padding: 14px;
  background: #FFFFFF;
  border-radius: 14px;

  .btn {
    width: 103px;
    height: 42px;
    background: #FF7F41;
    border-radius: 21px;
    cursor: pointer;
    text-align: center;
    font-size: 22px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 31px;
    padding-top: 5px;
  }

  .icon {
    width: 181px;
    height: 76px;
  }

  .text {
    width: 203px;
    margin: 0 54px 0 14px;
    font-size: 25px;
    font-weight: 500;
    color: #333333;
    line-height: 36px;
    @extend .ellipsis-2;
  }
  .img {
    position: absolute;
    top: 0;
    right: 0;
    width: 56px;
    height: 56px;
  }
}
</style>
